// @flow
import RolesPage from './RolesPage.js';
export default RolesPage;



// WEBPACK FOOTER //
// ./src/view/Pages/RolesPage/index.js